import classNames from "classnames";
import _ from "lodash";
import React, { PropTypes } from "react";
import { ButtonToolbar } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SubmissionError } from "redux-form";

import {
  ArchiveButton,
  CheckboxButton,
  EditButton,
  Render,
} from "../../../../common";
import { DataTable } from "../../../../common/DataTable";
import MessageBox from "../../../../common/MessageBox";
import { BasicClassFields } from "./";

import * as types from "../../../../../utils/data/dataActionTypes";
import * as dataActions from "../../../../../utils/data/dataActions";
import { CLASSES, CLIENT_COVERAGES, DIVISIONS } from "../../../../../utils/data/models";
import { PERCENTAGE } from "./enums/fiscalSplitTypes";

import { toast } from "react-toastify";
import {
  AGENT,
  DIRECTOR,
  FINANCE,
  FINTECH,
} from "../../../../../utils/Roles";
import userHasAccess from "../../../../../utils/userHasAccess";
import { getRetroactiveLimitDate } from "../../../../common/RetroactiveData/RetroactiveLimitHelper";
import { LIST_API_HOOK_ERRORS } from "../../../../common/enums/apiHooksErrorType";
import { RectangleSpinner } from "../../../../common/spinners";
import { canViewSyncForTEDDesjardins, canViewSyncStatus, getLatestClassSyncs, getOverlayForSync } from "../../../../common/synchronization/SynchronizationHelper";
import { SUCCESS } from "../../../synchronization/enums/syncStatusTypes";
import { ACTIVE, IMPLEMENTATION, INACTIVE, TERMINATED } from "../../enums/clientStatusTypes";
import { DANGER, SUCCESS as SUCCESS_STATUS, WARNING } from "../../enums/messageBoxTypes";
import { ELIGIBILITY } from "../../enums/synchronizationOptions";
import { CLASS } from "../../../synchronization/enums/syncElementTypes";
import { isSimpleFetchToast } from "../../../../common/RouteValidators/ClientValidationHelper";

class ClassesDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      maximumRetroactiveDate: undefined,
      fetchingMaximumRetroactiveDate: true,
      latestSyncs: null,
      syncStatus: "",
      classSyncDictionary: {},
      fetchingModalData: false,
      blockInactivationSubmission: false,
    };
    this.archiveClass = this.archiveClass.bind(this);
    this.createClass = this.createClass.bind(this);
    this.getCoverageData = this.getCoverageData.bind(this);
    this.generateConfirmationTitle = this.generateConfirmationTitle.bind(this);
    this.setCellClassName = this.setCellClassName.bind(this);
    this.toggleArchivedClasses = this.toggleArchivedClasses.bind(this);
    this.getDivisionName = this.getDivisionName.bind(this);
    this.updateClass = this.updateClass.bind(this);
    this.newClass = this.newClass.bind(this);
    this.getData = this.getData.bind(this);
    this.getViewOnlyForClasses = this.getViewOnlyForClasses.bind(this);
    this.setBlockInactivationSubmission = this.setBlockInactivationSubmission.bind(this);

    this.viewOnlyForImplementation = !userHasAccess(FINANCE);
    this.viewOnlyForActive = !userHasAccess(DIRECTOR);
    this.viewOnlyForTermination = !userHasAccess(FINTECH);
    this.setmaximumRetroactiveDate = this.setmaximumRetroactiveDate.bind(this);
    this.getClassSyncByClass = this.getClassSyncByClass.bind(this);

    this.shouldDisplaySync = canViewSyncStatus(this.props.activeClient, CLASS);
    this.shouldDisplaySyncForTEDDesjardins = canViewSyncForTEDDesjardins(this.props.activeClient);
  }

  componentWillMount() {
    this.props.dataActions.clearDataList(CLASSES);
    this.props.dataActions.clearDataList(CLIENT_COVERAGES);
    this.props.dataActions.getDataList(
      CLIENT_COVERAGES,
      0,
      0,
      "",
      ["guaranteeId:asc"],
      [`clientId==${this.props.clientId}`]
    );
    this.props.dataActions.getDataList(
      DIVISIONS,
      0,
      0,
      "",
      ["name:asc"],
      [`divisions.clientId==${this.props.clientId}`, DIVISIONS.archiveFilter]
    );
    this.setmaximumRetroactiveDate();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.clientId !== this.props.clientId) {
      this.props.dataActions.clearDataList(CLASSES);
      this.props.dataActions.getDataList(
        CLIENT_COVERAGES,
        0,
        0,
        "",
        ["guaranteeId:asc"],
        [`clientId==${nextProps.clientId}`]
      );
      this.props.dataActions.getDataList(
        DIVISIONS,
        0,
        0,
        "",
        ["name:asc"],
        [`divisions.clientId==${nextProps.clientId}`, DIVISIONS.archiveFilter]
      );
      this.setmaximumRetroactiveDate();
    }
  }

  componentWillUnmount() {
    this.props.dataActions.clearDataList(CLIENT_COVERAGES);
  }

  setBlockInactivationSubmission(value) {
    this.setState({ blockInactivationSubmission: value });
  }

  getViewOnlyForClasses() {
    const { clientStatusType } = this.props;

    switch (clientStatusType) {
      case IMPLEMENTATION.value:
        return this.viewOnlyForImplementation;
      case ACTIVE.value:
      case INACTIVE.value:
        return this.viewOnlyForActive;
      case TERMINATED.value:
        return this.viewOnlyForTermination;
    }
  }

  archiveClass(classId, isArchived) {
    this.props.dataActions
      .updateDataItem(CLASSES, { classId, isArchived: !isArchived, clientId: this.props.clientId })
      .then((data) => {
        if (data.type === types.UPDATE_DATA_ITEM_FAILURE) {
          if (LIST_API_HOOK_ERRORS.includes(data.payload.error.data.message)) {
            toast(
              <FormattedMessage id={data.payload.error.data.message} />,
              {
                type: toast.TYPE.ERROR,
                autoClose: false,
              }
            );
          }
          else if (data.payload.error.data.error === "class_active_coverage_error") {
            toast(
              <FormattedMessage id="clientClasses.errors.classActiveCoverageError" />,
              {
                type: toast.TYPE.ERROR,
                autoClose: false,
              }
            );
          }
        } else {
          this.getData(
            this.props.offset,
            this.props.limit,
            this.props.q,
            this.props.sortBy,
            this.props.filters
          );
        }
      }
      );
  }
  setmaximumRetroactiveDate() {
    getRetroactiveLimitDate(this.props.clientId, (result) => {
      this.setState({
        maximumRetroactiveDate: result,
        fetchingMaximumRetroactiveDate: false
      });
    });
  }


  createClass(values) {
    const {
      classId,
      clientId,
      name,
      classNumber,
      divisionId,
      externalClassNumber,
      valueType,
      splitsActiveIn = [],
      splitsActiveOut = [],
      billingPeriodId,
    } = values;

    const classClientCoverages = splitsActiveIn
      .concat(splitsActiveOut)
      .map((split) => {
        const { value = 0, ...rest } = split;
        const isOutOfOptimization = splitsActiveOut.includes(split);
        return { ...rest, valueType, isOutOfOptimization, value };
      });

    const dataToUpdate = {
      classId,
      clientId,
      name,
      classNumber,
      divisionId,
      externalClassNumber,
      valueType,
      classClientCoverages,
      billingPeriodId: Number(billingPeriodId),
    };

    return this.props.dataActions
      .createDataItem(CLASSES, dataToUpdate)
      .then((data) => {
        if (data.type === types.CREATE_DATA_ITEM_FAILURE && LIST_API_HOOK_ERRORS.includes(data.payload.error.data.message)) {
          throw new SubmissionError({
            name: {
              messageKey:
                data.payload.error.data.message,
              values: {},
              state: "error",
            },
          });
        }
        else {
          this.getData(
            this.props.offset,
            this.props.limit,
            this.props.q,
            this.props.sortBy,
            this.props.filters,
            data.type
          );
        }
      });
  }

  getCoverageData(clientId, classId, edit=false) {
    toast(
      <FormattedMessage id="loading"/>,
      {
        type: toast.TYPE.INFO,
        autoClose: false,
      }
    );

    if(edit) {
      this.setState({ fetchingModalData: true});
    }
    if (typeof classId != "undefined") {
      return this.props.dataActions
        .getDataItem(CLASSES, classId, {
          fields:
            "classClientCoverages(*),classId,classNumber,externalClassNumber,clientId,isArchived,name,divisionId",
        })
        .then(() => {
          this.props.dataActions.getDataList(
            CLIENT_COVERAGES,
            0,
            0,
            "",
            ["guaranteeId:asc"],
            [`clientId==${clientId}`]
          ).then(() => toast.dismiss());
        });
    } else {
      return this.props.dataActions.getDataList(
        CLIENT_COVERAGES,
        0,
        0,
        "",
        ["guaranteeId:asc"],
        [`clientId==${clientId}`]
      ).then(() => toast.dismiss());
    }
  }

  orderSplits(a, b) {
    if (a.order < b.order) {
      return -1;
    }
    if (a.order > b.order) {
      return 1;
    }
    return 0;
  }

  mergeData() {
    if (
      !!this.props.active &&
      !!this.props.clientCoverages &&
      this.props.clientCoverages.length
    ) {
      const valueType = this.props.active.classClientCoverages.length
        ? this.props.active.classClientCoverages[0].valueType
        : "FIXED";
      let data = {
        clientId: this.props.clientId,
        classId: this.props.active.classId,
        classNumber: this.props.active.classNumber,
        externalClassNumber: this.props.active.externalClassNumber,
        name: this.props.active.name,
        divisionId: this.props.active.divisionId,
        valueType,
      };

      const activeClientCoverages = [];
      const inactiveClientCoverages = [];
      this.props.clientCoverages.forEach((clientCoverage) => {
        let match = this.props.active.classClientCoverages.find(
          (classClientCoverage) =>
            classClientCoverage.clientCoverageId ===
            clientCoverage.clientCoverageId
        );
        if (match) {
          activeClientCoverages.push({
            ...match,
            isActive: true,
            guarantee: clientCoverage.guarantee,
          });
        } else {
          inactiveClientCoverages.push({
            ...clientCoverage,
            isActive: false,
            guarantee: clientCoverage.guarantee,
          });
        }
      });
      const clientCoverages = activeClientCoverages.concat(
        inactiveClientCoverages
      );
      let splitsActiveIn = [];
      let inCount = 0;
      let splitsActiveOut = [];
      let outCount = 0;
      let splitsInactive = [];
      let offCount = 0;
      const splits = clientCoverages
        .sort(this.orderSplits)
        .filter((clientCoverage) => !clientCoverage.isArchived)
        .map((clientCoverage) => {
          const description = clientCoverage.description
            ? clientCoverage.description
            : _.get(clientCoverage, "clientCoverage.description", "");
          const split = {
            name: `${clientCoverage.guarantee.localizations[this.props.languageCode]
              .name
              }${!!description ? ` (${description})` : ""}`,
            isActive: clientCoverage.isActive,
            isOutOfOptimization: clientCoverage.isOutOfOptimization,
            order: clientCoverage.order,
            excludedFromEmployerContribution:
              clientCoverage.excludedFromEmployerContribution,
            value: clientCoverage.value || 0,
            clientCoverageId: clientCoverage.clientCoverageId,
            guaranteeId: clientCoverage.guarantee.guaranteeId,
          };

          if (split.isActive && split.isOutOfOptimization) {
            outCount++;
            splitsActiveOut.push({
              ...split,
              order: outCount,
              value: split.value.toString(),
            });
          } else if (split.isActive && !split.isOutOfOptimization) {
            inCount++;
            splitsActiveIn.push({
              ...split,
              order: inCount,
              value: split.value.toString(),
            });
          } else {
            offCount++;
            splitsInactive.push({
              ...split,
              order: offCount,
              value: split.value.toString(),
            });
          }

          return split;
        });

      return {
        ...data,
        splits,
        splitsActiveIn,
        splitsActiveOut,
        splitsInactive,
      };
    }

    return null;
  }

  newClass() {
    const splits = this.props.clientCoverages.map((clientCoverage, i) => {
      return {
        name: `${clientCoverage.guarantee.localizations[this.props.languageCode].name
          }${clientCoverage.description ? ` (${clientCoverage.description})` : ""
          }`,
        classNumber: clientCoverage.classNumber,
        externalClassNumber: clientCoverage.externalClassNumber,
        isActive: clientCoverage.isActive,
        isArchived: clientCoverage.isArchived,
        isOutOfOptimization: clientCoverage.isOutOfOptimization,
        order: clientCoverage.order || i + 1,
        value: clientCoverage.value || 0,
        clientCoverageId: clientCoverage.clientCoverageId,
        guaranteeId: clientCoverage.guarantee.guaranteeId,
      };
    });
    return {
      valueType: PERCENTAGE.value,
      clientId: this.props.clientId,
      splits,
      splitsInactive: splits,
    };
  }

  setCellClassName(clientClass) {
    return classNames({
      archived: clientClass.isArchived,
    });
  }

  getClassSyncByClass(clientClass) {
    const classSyncs = this.state.classSyncDictionary;
    if (classSyncs && Object.keys(classSyncs).length > 0) {
      return classSyncs[clientClass.classId] || {};
    }
    return {};
  }

  getDivisionName(divisionId) {
    const divisions = this.props.divisions;
    const divFiltered = divisions.filter((d) => (d.divisionId == divisionId));
    if (divFiltered.length > 0) {
      return divFiltered[0].name;
    }
    return "";
  }

  toggleArchivedClasses() {
    const isArchivedFiltered = this.props.filters.includes(
      CLASSES.archiveFilter
    );
    const filters = isArchivedFiltered
      ? this.props.filters.filter((filter) => filter !== CLASSES.archiveFilter)
      : [...this.props.filters, CLASSES.archiveFilter];
    return this.getData(
      this.props.offset,
      this.props.limit,
      this.props.q,
      this.props.sortBy,
      filters
    );
  }

  updateClass(values) {
    const {
      classId,
      name,
      classNumber,
      externalClassNumber,
      valueType,
      splitsActiveIn = [],
      splitsActiveOut = [],
      billingPeriodId,
    } = values;
    const classClientCoverages = splitsActiveIn
      .concat(splitsActiveOut)
      .map((split) => {
        const { value = 0, ...rest } = split;
        const isOutOfOptimization = splitsActiveOut.includes(split);
        return { ...rest, valueType, isOutOfOptimization, value };
      });

    const dataToUpdate = {
      classId,
      name,
      classNumber,
      externalClassNumber,
      valueType,
      classClientCoverages,
      clientId: this.props.clientId,
      billingPeriodId: Number(billingPeriodId),
    };

    return this.props.dataActions
      .updateDataItem(CLASSES, dataToUpdate)
      .then((data) => {
        if (data.type === types.UPDATE_DATA_ITEM_FAILURE && LIST_API_HOOK_ERRORS.includes(data.payload.error.data.message)) {
          throw new SubmissionError({
            name: {
              messageKey:
                data.payload.error.data.message,
              values: {},
              state: "error",
            },
          });
        }
        else {
          const isSimpleFetchError = isSimpleFetchToast(data);
          this.getData(
            this.props.offset,
            this.props.limit,
            this.props.q,
            this.props.sortBy,
            this.props.filters,
            data.type,
            isSimpleFetchError
          );
        }
        this.setState({ fetchingModalData: false });
      });
  }

  getCols() {
    let cols = [
      {
        name: <FormattedMessage id="clientClasses.datatable.columns.class" />,
        key: "name",
        display: (clientClass) => (
          <span className={this.setCellClassName(clientClass)}>
            {clientClass.name}
          </span>
        ),
        widthPct: this.shouldDisplaySync ? 20 : this.shouldDisplaySyncForTEDDesjardins ? 50 : 70,
      }
    ];
    this.shouldDisplaySync &&

      cols.push(
        {
          name: <FormattedMessage id="clientClasses.datatable.columns.division" />,
          key: "division",
          display: (clientClass) => {
            return (<span>{this.getDivisionName(clientClass.divisionId)}</span>);
          },
          widthPct: 20,
        }
      );
    if (this.shouldDisplaySync || this.shouldDisplaySyncForTEDDesjardins) {
      cols.push(
        {
          name: <FormattedMessage id="clientClasses.datatable.columns.externalClassNumber" />,
          key: "externalClassNumber",
          display: (clientClass) => {
            return (
              <span className={this.setCellClassName(clientClass)}>{clientClass.externalClassNumber}</span>
            );
          },
          widthPct: 20,
        },
      );
    }

    this.shouldDisplaySync &&
      cols.push(
        {
          name: <FormattedMessage id="clientClasses.datatable.columns.sync" />,
          display: (clientClass) => {
            const { latestSyncs } = this.state;
            if (!latestSyncs) {
              return <RectangleSpinner className="spinner-rect-col" />;
            }
            const latestClassSync = latestSyncs.find((e) => e.classId === clientClass.classId);
            const data = { "clientClass": _.cloneDeep(clientClass), "client": this.props.activeClient };
            return getOverlayForSync(
              data,
              latestClassSync,
              "clientClasses.datatable",
              "",
              "",
              "",
              false
            );
          },
          widthPct: 10,
        });

    cols.push({
      name: <FormattedMessage id="datatable.actions" />,
      display: (clientClass) => this.generateActionButtons(clientClass),
      widthPct: 30,
    });
    return cols;
  }
  renderFormatedMessage(icon) {
    return <span className="icon warning">{icon}</span>;
  }

  generateActionButtons(clientClass) {

    const viewOnly = this.getViewOnlyForClasses() || this.props.isArchived;

    return (
      <ButtonToolbar key={clientClass.classId}>
        <EditButton
          title={
            <FormattedMessage
              id={`clientClasses.datatable.actions.${viewOnly ? "view" : "edit"
                }`}
            />
          }
          label={
            <FormattedMessage id={viewOnly ? "common.view" : "common.edit"} />
          }
          confirmationTitle={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
              {this.renderFormatedMessage}
            </FormattedMessage>
          }
          confirmationMessage={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
          }
          modalClassName="large-modal"
          form={BasicClassFields}
          allowSubmission={!viewOnly}
          blockSubmission={this.state.blockInactivationSubmission}
          onModalClosed={() => this.setState({ fetchingModalData: false })}
          disabled={this.state.fetchingModalData}
          props={{
            disabled: viewOnly,
            viewOnly,
            maximumRetroactiveDate: this.state.maximumRetroactiveDate,
            fetchingMaximumRetroactiveDate: this.state.fetchingMaximumRetroactiveDate,
            clientBillingPeriodType: this.props.clientBillingPeriodType,
            clientStatusType: this.props.clientStatusType,
            divisionOptions: this.props.divisionOptions,
            isNewClass: false,
            syncType: this.props.syncType,
            syncStatus: this.shouldDisplaySync ? this.getClassSyncByClass(clientClass) : "",
            clientLastActiveDate: this.props.clientLastActiveDate,
            setBlockInactivationSubmission: this.setBlockInactivationSubmission,
          }}
          data={
            !!this.props.active &&
              this.props.active.classId === clientClass.classId
              ? this.mergeData()
              : null
          }
          getData={() => this.getCoverageData(this.props.clientId, clientClass.classId, true)}
          waitForData={true}
          parentComponentDataLoad={true}
          editFunction={this.updateClass}
          requiresCloseConfirmation={true}
          confirmOnClose={true}
        />
        <Render for={DIRECTOR} if={!viewOnly && !clientClass.isArchived}>
          <ArchiveButton
            isArchived={clientClass.isArchived}
            archivedName={clientClass.name}
            showDefaultDanger={true}
            archiveFunction={this.archiveClass.bind(
              null,
              clientClass.classId,
              clientClass.isArchived
            )}
            label={
              clientClass.isArchived ? (
                <FormattedMessage id="common.unarchive" />
              ) : (
                <FormattedMessage id="common.archive" />
              )
            }
          />
        </Render>
      </ButtonToolbar>
    );
  }

  generateAddButton(clientId) {
    const hasNoDivisions = this.props.syncType == ELIGIBILITY.value && this.props.divisionOptions.length == 0;
    if (this.props.fetched && this.props.clientCoverages.length === 0) {
      return (
        <MessageBox key="coverageError" className="alert-warning">
          <FormattedMessage id="clientClasses.datatable.actions.warnings.noCoverages" />
        </MessageBox>
      );
    } else {
      const viewOnly = this.getViewOnlyForClasses();
      return (
        <div>
          <CheckboxButton
            className="include-archived"
            id="archived"
            label={
              <FormattedMessage id="clientClasses.datatable.actions.includeArchivedClasses" />
            }
            checked={!this.props.filters.includes(CLASSES.archiveFilter)}
            onClick={this.toggleArchivedClasses}
          />
          <Render
            for={AGENT}
            if={!viewOnly}
          >
            <EditButton
              title={
                <FormattedMessage id="clientClasses.datatable.actions.add" />
              }
              label={<FormattedMessage id="common.add" />}
              modalClassName="large-modal"
              add={true}
              form={BasicClassFields}
              allowSubmission={!hasNoDivisions}
              blockSubmission={this.state.blockInactivationSubmission}
              data={this.props.clientCoverages.length ? this.newClass() : null}
              getData={this.getCoverageData.bind(this, clientId)}
              editFunction={this.createClass}
              confirmationTitle={
                <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
                  {this.renderFormatedMessage}
                </FormattedMessage>
              }
              props={{
                viewOnly,
                maximumRetroactiveDate: this.state.maximumRetroactiveDate,
                fetchingMaximumRetroactiveDate: this.state.fetchingMaximumRetroactiveDate,
                clientStatusType: this.props.clientStatusType,
                clientBillingPeriodType: this.props.clientBillingPeriodType,
                divisionOptions: this.props.divisionOptions,
                isNewClass: true,
                syncType: this.props.syncType,
                clientLastActiveDate: this.props.clientLastActiveDate,
                setBlockInactivationSubmission: this.setBlockInactivationSubmission,
              }}
              disabled={this.props.isArchived}
              confirmationMessage={
                <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
              }
              closeButtonKey="common.cancel"
              requiresCloseConfirmation={true}
              confirmOnClose={true}
            />
          </Render>
        </div>
      );
    }
  }

  generateConfirmationTitle() {
    return (
      <FormattedMessage id="clientClasses.datatable.actions.editConfirmationTitle">
        {this.renderFormatedMessage}
        confirmationMessage=
        {
          <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
        }
      </FormattedMessage>
    );
  }

  getData(offset, limit, q, sortBy, filters, actionType = "", isSimpleFetchError = false) {
    switch (actionType) {
      case types.CREATE_DATA_ITEM_FAILURE:
      case types.UPDATE_DATA_ITEM_FAILURE: {
        if (!isSimpleFetchError) {
          throw new SubmissionError({
            name: {
              messageKey:
                "validation.customMessages.serverErrors.duplicateClassName",
              values: {},
              state: "error",
            },
          });
        }
        break;
      }
      default: {
        return this.props.dataActions.getDataList(
          CLASSES,
          offset,
          limit,
          q,
          sortBy,
          filters,
          null,
          { clientId: this.props.clientId }
        ).then((res) => {
          return this.shouldDisplaySync && getLatestClassSyncs(this.props.clientId)
            .then((response) => {
              const classIds = res && res.payload.data ? res.payload.data.items.map((m) => m.classId) : [];
              const latestSyncs = response;
              this.setState({ latestSyncs: latestSyncs });
              if (classIds.length > 0) {
                let syncStatus = DANGER;
                let syncDictionary = {};

                if (Array.isArray(latestSyncs) && latestSyncs.length > 0) {
                  const successSyncs = latestSyncs.filter(
                    (sync) =>
                      sync.status === SUCCESS
                  );
                  const currentSuccessClassIds = [];
                  classIds.forEach((id) => {
                    syncDictionary[id] =
                      latestSyncs.find((sync) => sync.classId === id) || null;
                    if (successSyncs.length > 0) {
                      const presentClassIds = successSyncs.some(sync => sync.classId === id);
                      presentClassIds && currentSuccessClassIds.push(id);
                    }
                  });

                  if (currentSuccessClassIds.length > 0) {
                    syncStatus = currentSuccessClassIds.length == classIds.length ? SUCCESS_STATUS : WARNING;
                  }
                }
                this.setState({
                  syncStatus: syncStatus,
                  classSyncDictionary: syncDictionary,
                });
              }
            })
            .catch(() => {
              toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
                type: toast.TYPE.ERROR,
                autoClose: false,
              });
            });
        })
          .catch(() => {
            toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
              type: toast.TYPE.ERROR,
              autoClose: false,
            });
          });
      }
    }
  }

  render() {
    const datatableClasses = classNames({
      "classes-datatable": true,
      "no-coverage":
        this.props.fetched && this.props.clientCoverages.length === 0,
    });

    return (
      <div className={datatableClasses}>
        {this.shouldDisplaySync && this.state.syncStatus && <MessageBox className={`alert-${this.state.syncStatus}  synchronization-message-box-datatable`} >
          <span className="d-flex">
            <FormattedMessage id={`clientClasses.datatable.syncDisplayStatus.${this.state.syncStatus}`} />
          </span>
        </MessageBox>}

        <DataTable
          ref="dataTable"
          title={<FormattedMessage id="clientClasses.title" />}
          getData={this.getData}
          cols={this.getCols()}
          q={this.props.q}
          filters={this.props.filters}
          offset={this.props.offset}
          data={this.props.items}
          rowsPerPage={this.props.limit}
          totalRows={this.props.total}
          sortBy={this.props.sortBy}
          addButton={this.generateAddButton(this.props.clientId)}
          refreshFunction={this.getData}
        />
      </div>
    );
  }
}

ClassesDataTable.propTypes = {
  active: PropTypes.object,
  clientCoverages: PropTypes.array,
  dataActions: PropTypes.object,
  fetched: PropTypes.bool,
  filters: PropTypes.array,
  q: PropTypes.string,
  items: PropTypes.array,
  languageCode: PropTypes.string,
  limit: PropTypes.number,
  offset: PropTypes.number,
  sortBy: PropTypes.array,
  total: PropTypes.number,
  clientId: PropTypes.number,
  statuses: PropTypes.array,
  insuranceTypes: PropTypes.array,
  clientStatusType: PropTypes.string,
  isArchived: PropTypes.bool,
  activeClient: PropTypes.object,
  clientBillingPeriodType: PropTypes.string,
  syncType: PropTypes.string,
  divisionOptions: PropTypes.array,
  divisions: PropTypes.array,
  clientLastActiveDate: PropTypes.string,
};

function mapStateToProps(state) {
  const data = state.data.classes || {};
  const clientCoverages = state.data.clientCoverages || {};
  const newClient = data.clientId !== state.data.clients.active.clientId;
  const pagination = data.pagination || {};
  const divisions = state.data.divisions || {};
  const divisionOptions = (divisions.items || []).map((division) => ({
    value: division.divisionId,
    text: `${division.name} - ${division.externalDivisionNumber}`,
  }));
  return {
    active: data.active,
    activeClient: state.data.clients.active,
    q: data.q,
    filters: newClient
      ? [
        `clientId==${state.data.clients.active.clientId}`,
        CLASSES.archiveFilter,
      ]
      : data.filters,
    clientCoverages: clientCoverages.items || [],
    clientId: state.data.clients.active.clientId,
    clientStatusType: state.data.clients.active.clientStatusType,
    clientBillingPeriodType: state.data.clients.active.clientBillingPeriodType,
    isArchived: state.data.clients.active.isArchived,
    clientLastActiveDate: state.data.clients.active.lastActiveDate,
    syncType: state.data.clients.active.syncType,
    fetched: clientCoverages.fetched,
    limit: pagination.limit || 100,
    offset: pagination.offset || 0,
    sortBy: data.sortBy || ["name:asc"],
    total: pagination.totalCount || 0,
    items: data.items || null,
    languageCode: state.auth.user.languageCode,
    divisionOptions: divisionOptions || [],
    divisions: divisions.items || []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassesDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/classes/ClassesDataTable.js